
import React from 'react';
import { Col, Row, Image } from "react-bootstrap";
import { ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary, makeStyles, lighten } from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import FAQData from './FaqData';

import './FAQ.scss';

const useStyles = makeStyles(theme => ({
  expansionPanel: {
    borderTop: `0.25rem solid ${theme.palette.primary.main}`
  },
  background: {
    backgroundColor: lighten(theme.palette.primary.main, 0.92),
  },
}));

function buildList(list, index) {
  return (
    <ul key={index}>
      {list.map((listItem, i) => Array.isArray(listItem) ?
        buildList(listItem, i) :
        <li key={i}>{listItem}</li>
      )}
    </ul>
  );
}

function FAQCard(props) {
  const classes = useStyles();
  return (
    <Row>
      <ExpansionPanel className={(props.isTermInsuranceProduct || props.isFinalExpenseProduct || props.isWholeLifeProduct || props.isUniversalLifeProduct || props.isLoanProtectionProduct || props.isBusinessSolutions) ?`expansion-panel panel-ans`:`expansion-panel ${classes.expansionPanel}`} square>
        <ExpansionPanelSummary
          expandIcon={<KeyboardArrowDownIcon />}
          aria-controls="panel1-content"
          id={props.index}
          className='term-exp py-2 px-0'
          role=''
        >
          <span className= {(props.isTermInsuranceProduct || props.isFinalExpenseProduct || props.isWholeLifeProduct || props.isUniversalLifeProduct || props.isLoanProtectionProduc || props.isBusinessSolutions) ?"term-FAQuestion":"question"}>{props.question}</span>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className={props.isTermInsuranceProduct?'px-0 pt-0':'pb-3 px-0 pt-0'}>
        <div className='FAQ-ans'>
            {props.answer.map((paragraph, i) => Array.isArray(paragraph) ?
              buildList(paragraph, i)
              : <p key={i} dangerouslySetInnerHTML={{ __html: paragraph }}></p>)}
          </div>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </Row>
  )
}

export default function FAQs(props) {
  const classes = useStyles();
  let faqData = [];
  if (props.isAddDefaultFaq === false) {
    faqData = props.data
  }
  else if ((props.isPermProduct || props.isJuviProduct)) {
    faqData = props.data.concat(FAQData()
    .filter((data) => data.title !== "How much coverage should I purchase?"));  // Remove this default question from the perm product (#7258)
  }
  else {
    faqData = props.data.concat(FAQData());
  }

  return (
    <div className="faq-section">
      <Row className={(props.isTermInsuranceProduct || props.isFinalExpenseProduct || props.isWholeLifeProduct  || props.isUniversalLifeProduct || props.isLoanProtectionProduct  || props.isBusinessSolutions) ? `customizeterm-faq justify-content-center ${classes.background}`:"circle-section justify-content-center grey-section"}>
        {(!props.isTermInsuranceProduct && !props.isFinalExpenseProduct && !props.isWholeLifeProduct && !props.isUniversalLifeProduct && !props.isLoanProtectionProduct && !props.isBusinessSolutions) && <Image src="./circle.png" className="circle-1 position-absolute" alt="" />}
        <Col className="content-section">
          <Row className="mx-3 mb-4 justify-content-center">
            <h2 className='FAQ-term text-center'>Frequently Asked Questions</h2>
          </Row>
          {faqData.map((faq, index) => <FAQCard title={props.title} 
            isTermInsuranceProduct={props.isTermInsuranceProduct} 
            isFinalExpenseProduct={props.isFinalExpenseProduct} 
            isWholeLifeProduct={props.isWholeLifeProduct} 
            isUniversalLifeProduct={props.isUniversalLifeProduct} 
            isBusinessSolutions={props.isBusinessSolutions}
            isLoanProtectionProduct={props.isLoanProtectionProduct} key={index} index={index} question={faq.title} answer={faq.text} />)}
        </Col>
        {(!props.isTermInsuranceProduct && !props.isFinalExpenseProduct && !props.isWholeLifeProduct && !props.isUniversalLifeProduct && !props.isLoanProtectionProduct && !props.isBusinessSolutions) &&  <div className="mt-auto position-relative">
          <Image src="./circle.png" className="circle-2 position-absolute" alt="" />
        </div>}
      </Row>
    </div>
  );
};


// WEBPACK FOOTER //
// ./src/components/LandingPages/FAQs/FAQs.js